import { Popover, Typography } from "@mui/material";
import React from "react";
import { getSiteIconName } from "../../../../utils/CommonUtils";
import CustomIcon from "../../CustomIcons/CustomIcon";
import classes from "./SitesPopover.module.css";

const SitesPopover = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const sites = props.sites;
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <span>
            {sites?.map((site, index) => (
              <CustomIcon
                className={classes.icons}
                key={`${site.id}-${index}`}
                iconName={getSiteIconName(site.clientId)}
              />
            ))}
          </span>
        </Typography>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        
      >
        <div sx={{ p: 1 }}>
          {sites?.map((site) => {
            return (
              <div key={site.id} className={classes.site}>
                <CustomIcon iconName={getSiteIconName(site.clientId)} />
                <span className={classes.displayName}>{site.displayName}</span>
                {site.userType && <span className={classes.userType}> , {site.userType}</span>}
              </div>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};

export default SitesPopover;
